import React from "react";
import { ImageUpload, ImageUploadMetadata, ToggleSwitch } from "../../../../components";
import { SidebarFormProps } from "./SidebarForm";
import { stripQuery, withSiteId } from "../../../../helpers/imageUri";
import { useTranslations } from "../../../../contexts";
import { DesignerSectionHeading } from "./DesignerSectionHeading";

export const SidebarFormPhotos: React.FC<SidebarFormProps> = (props) => {
  const i18n = useTranslations();
  const isEnabled = Boolean(props.form.photos?.is_enabled);
  const { siteId } = props;

  const setImageMetadata = (uri: string, metadata?: ImageUploadMetadata) => {
    if (!metadata) return;
    const cleanedUri = stripQuery(uri);
    props.setImageMetadata?.({
      ...props.imageMetadata,
      [cleanedUri]: metadata,
    });
  };

  return (
    <div
      id="photos-form"
      className="border-b p-6"
      data-preview-section="gallery"
    >
      <div className="flex items-start">
        <DesignerSectionHeading
          className="grow pb-4"
          title={i18n.Photos}
          helpLabel={`${i18n.designerHelpFor} ${i18n.Photos}`}
          helpText={i18n.designerPhotosHelp}
        />
        <ToggleSwitch
          aria-label={`${i18n.designerShowSection}: ${i18n.Photos}`}
          checked={isEnabled}
          onChange={() =>
            props.setForm({
              ...props.form,
              photos: {
                ...props.form.photos,
                is_enabled: !isEnabled,
              },
            })
          }
        />
      </div>
      {isEnabled && (
        <div className="grid grid-cols-3 gap-3">
          {(props.form.photos?.items || []).map((photo, index) => (
            <ImageUpload
              key={photo.uri}
              usage="photo"
              image={photo.uri ? withSiteId(photo.uri, siteId) : photo.uri}
              onChange={({ uri, metadata }) => {
                const cleanedUri = stripQuery(uri);
                setImageMetadata(uri, metadata);
                props.setForm({
                  ...props.form,
                  photos: {
                    ...props.form.photos,
                    items: (props.form.photos?.items || []).map(
                      (item, _index) =>
                        index !== _index ? item : { ...item, uri: cleanedUri }
                    ),
                  },
                });
              }}
              onDelete={() => {
                props.setForm({
                  ...props.form,
                  photos: {
                    ...props.form.photos,
                    items:
                      props.form.photos?.items?.filter(
                        (_, _index) => index !== _index
                      ) || [],
                  },
                });
              }}
            />
          ))}
          <ImageUpload
            usage="photo"
            onChange={({ uri, metadata }) => {
              const cleanedUri = stripQuery(uri);
              setImageMetadata(uri, metadata);
              props.setForm({
                ...props.form,
                photos: {
                  ...props.form.photos,
                  items: [...(props.form.photos?.items || []), { uri: cleanedUri }],
                },
              });
            }}
          />
        </div>
      )}
    </div>
  );
};
